import { render, staticRenderFns } from "./TerminalFile.vue?vue&type=template&id=46982063&scoped=true&"
import script from "./TerminalFile.vue?vue&type=script&lang=js&"
export * from "./TerminalFile.vue?vue&type=script&lang=js&"
import style0 from "./TerminalFile.vue?vue&type=style&index=0&id=46982063&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46982063",
  null
  
)

export default component.exports